import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDraft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.8512 8.2466L13.2525 6.64788L13.8567 6.04371C13.9887 5.91599 14.1556 5.85213 14.3572 5.85213C14.5588 5.85213 14.7235 5.91599 14.8512 6.04371L15.4554 6.64788C15.5831 6.77992 15.647 6.94676 15.647 7.1484C15.647 7.35003 15.5831 7.51472 15.4554 7.64244L14.8512 8.2466ZM7.91602 13.5831V11.9844L12.3567 7.54371L13.9554 9.14244L9.51474 13.5831H7.91602ZM0.416016 9.26292V7.83854H6.89518V9.26292H0.416016ZM0.416016 5.70585V4.28646H10.3771V5.70585H0.416016ZM0.416016 2.15375V0.734375H10.3771V2.15375H0.416016Z" })
});
export default SvgDraft;
